import React, { useContext, useState } from 'react';
import {
    faCalendarDay,
} from '@fortawesome/free-solid-svg-icons';
import Button from 'components/UI/Button';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectHotel from 'components/UI/Input/SelectHotel';
import { ThemeContext } from 'utils/context';

function QuotesFilters({ onFiltersUpdate, isLoading })
{
    const initialFilters = {
        checkinAfter: null,
        checkinBefore: null,
        quoteDateAfter: null,
        bookingHotel: null,
    };

    const {
        darkMode,
    } = useContext(ThemeContext);
    const [filters, setFilters] = useState({ ...initialFilters });
    const cleanFilters = () =>
    {
        setFilters({ ...initialFilters });
        onFiltersUpdate(filters);
    };

    const onChangeFilters = (filter, value) =>
    {
        setFilters({ ...filters, [filter]: value });
    };

    const updateFilters = () =>
    {
        if (onFiltersUpdate)
        {
            onFiltersUpdate(filters);
        }
    };

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-mt-3">
            <div className="tw-flex tw-flex-col tw-p-4 tw-bg-white tw-rounded-none dark:tw-bg-neutral-700">

                <div className="tw-grid tw-w-full tw-grid-cols-4 max-xl:tw-grid-cols-2 tw-p-5 max-[850px]:tw-grid-cols-2 tw-gap-4">
                    <div className="tw-w-full tw-relative tw-h-fit">
                        <label htmlFor="checkinAfter" className="tw-font-bold tw-text-black tw-text-sm tw-mb-3 dark:tw-text-neutral-300">Check-in</label>
                        <div className="tw-relative">
                            <DatePicker calendarClassName={`${darkMode ? 'react-datepicker__dark' : ''}`} readonly={isLoading} id="checkinAfter" className="tw-px-3 tw-py-1.5 tw-border tw-bg-neutral-lightest tw-transition-all tw-rounded tw-w-full tw-h-10 tw-outline-none hover:tw-border-primary-default focus:tw-border-primary-default dark:tw-bg-neutral-800 dark:tw-border-neutral-500" selected={filters.checkinAfter} onChange={(date) => onChangeFilters('checkinAfter', date)} />
                            <label htmlFor="checkinAfter">
                                <FontAwesomeIcon className="tw-absolute tw-right-2 tw-top-0 tw-bottom-0 tw-my-auto" icon={faCalendarDay} />
                            </label>
                        </div>
                    </div>

                    <div className="tw-w-full tw-relative tw-h-fit">
                        <label htmlFor="checkinBefore" className="tw-font-bold tw-text-black tw-text-sm tw-mb-3 dark:tw-text-neutral-300">Check-out</label>
                        <div className="tw-relative">
                            <DatePicker calendarClassName={`${darkMode ? 'react-datepicker__dark' : ''}`} readonly={isLoading} id="checkinBefore" className="tw-px-3 tw-py-1.5 tw-border tw-bg-neutral-lightest tw-transition-all tw-rounded tw-w-full tw-h-10 tw-outline-none hover:tw-border-primary-default focus:tw-border-primary-default dark:tw-bg-neutral-800 dark:tw-border-neutral-500" selected={filters.checkinBefore} onChange={(date) => onChangeFilters('checkinBefore', date)} />
                            <label htmlFor="checkinBefore">
                                <FontAwesomeIcon className="tw-absolute tw-right-2 tw-top-0 tw-bottom-0 tw-my-auto" icon={faCalendarDay} />
                            </label>
                        </div>
                    </div>
                    <div className="tw-w-full tw-relative tw-h-fit">
                        <label htmlFor="quoteDateAfter" className="tw-font-bold tw-text-black tw-text-sm tw-mb-3 dark:tw-text-neutral-300">Quote Date After</label>
                        <div className="tw-relative">
                            <DatePicker calendarClassName={`${darkMode ? 'react-datepicker__dark' : ''}`} readonly={isLoading} id="quoteDateAfter" className="tw-px-3 tw-py-1.5 tw-border tw-bg-neutral-lightest tw-transition-all tw-rounded tw-w-full tw-h-10 tw-outline-none hover:tw-border-primary-default focus:tw-border-primary-default dark:tw-bg-neutral-800 dark:tw-border-neutral-500" selected={filters.quoteDateAfter} onChange={(date) => onChangeFilters('quoteDateAfter', date)} />
                            <label htmlFor="quoteDateAfter">
                                <FontAwesomeIcon className="tw-absolute tw-right-2 tw-top-0 tw-bottom-0 tw-my-auto" icon={faCalendarDay} />
                            </label>
                        </div>
                    </div>
                    <div className="tw-w-full tw-relative tw-h-fit">
                        <label htmlFor="bookingHotel" className="tw-font-bold tw-text-black tw-text-sm tw-mb-3 dark:tw-text-neutral-300">Hotel</label>
                        <div className="tw-relative">
                            <SelectHotel value={filters.bookingHotel} onChange={(value) => onChangeFilters('bookingHotel', value.id)} id="bookingHotel" className="tw-px-3 tw-border tw-bg-neutral-lightest tw-transition-all tw-rounded tw-w-full tw-h-10 tw-outline-none hover:tw-border-primary-default focus:tw-border-primary-default dark:tw-bg-neutral-800 dark:tw-border-neutral-500" />
                        </div>
                    </div>

                </div>
                <div className="tw-flex tw-flex-row tw-justify-end tw-flex-end tw-flex-1 tw-w-64 tw-p-5 tw-mr-0 tw-ml-auto">
                    <Button
                        margin="tw-mt-0 tw-mr-2"
                        type="secondary"
                        className="tw-border tw-border-neutral-200"
                        onClick={() =>
                        {
                            cleanFilters();
                        }}
                    >
                        Clear
                    </Button>
                    <Button
                        margin="tw-mt-0 tw-mr-0"
                        type="primary"
                        onClick={() =>
                        {
                            updateFilters();
                        }}
                    >
                        Apply
                    </Button>
                </div>
            </div>
        </div>
    );
}

QuotesFilters.defaultProps = {
    isLoading: false,
};

QuotesFilters.propTypes = {
    onFiltersUpdate: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default QuotesFilters;
